import { useEffect, useState } from 'react'
import { GetRequest } from '../../../Utils/hooks/ApiHandler'
import { useGetEssentials } from '../../../Utils/hooks/useGetEssentials'
import { Col, Row } from 'react-bootstrap';
import { IconBrandGoogle, IconBrandLinkedin, IconBrandMeta, IconCashBanknoteFilled, IconCategoryFilled, IconChartPie2Filled, IconClock, IconEye, IconMail, IconMessage } from '@tabler/icons-react';
import { TopLeadCampaigns } from './marketingModules/TopLeadCampaigns';
import { CampaignPerformance } from './marketingModules/CampaignPerformance';
import { LeadSourceOverview } from '../financialDashboard/Modules/LeadSourceOverview';
import { SalesStatsCard } from '../commonComponents/SalesStatsCard';
import { FunnelSnapshot } from './marketingModules/FunnelSnapshot';
import { SalesStatusCard } from './marketingModules/SalesStatusCard';

export const MarketingDashboard = () => {
    const { headers, extras, customerId, loginUserId, userType } = useGetEssentials()

    const [salesAnalyticsData, setSalesAnalyticsData] = useState([])
    const [duration, setDuration] = useState('week')
    const fetching = async () => {
        try {
            const res = await GetRequest(`Sales_dashboard/CardDetails/${customerId}/${loginUserId}/${userType}/${duration}`, { headers }, extras)
            if (res.status === "fail" || res.success === false) {
                setSalesAnalyticsData([])
                return
            }
            setSalesAnalyticsData(res.data)
        } catch (error) {
            return
        }
    }
    useEffect(() => {
        fetching()
    }, [duration])


    const topCardData = [
        { label: "Leads Generated", icon: <IconCategoryFilled size={24} color='white' />, value: "503", percent: '12.5', iconBg: "#e04e17", isCurrency: false },
        { label: "Cost Per Lead", icon: <IconCashBanknoteFilled size={24} color='white' />, value: "5000", percent: '21.30', iconBg: "#28ae60", isCurrency: true },
        { label: "Cost / Acquisition", icon: <IconClock size={24} color='#f5a623' />, value: 4920, percent: "32.5", iconBg: "#fef4e3", isCurrency: true },
        { label: "Campaign ROI", icon: <IconChartPie2Filled size={24} color='white' />, value: 4920, percent: "32.5", iconBg: "#0f9384", isCurrency: true },
        { label: "Website Visitors", icon: <IconEye size={24} color='#5b5fef' />, value: 4920, percent: "32.5", iconBg: "#eef0fe", isCurrency: true },
        { label: "Landing Page Conv.", icon: <IconMessage size={24} color='#e5484d' />, value: 4920, percent: "32.5", iconBg: "#fdecec", isCurrency: true },
    ]
    const socialData = [
        { label: "Google Ads", icon: <IconBrandGoogle size={24} color='white' />, value: "503", percent: '12.5', iconBg: "#e04e17", isCurrency: false },
        { label: "Meta Ads", icon: <IconBrandMeta size={24} color='white' />, value: "5000", percent: '21.30', iconBg: "#597dff", isCurrency: true },
        { label: "LinkedIn", icon: <IconBrandLinkedin size={24} color='white' />, value: 9028, percent: "32.5", iconBg: "#5870f8", isCurrency: true },
        { label: "Email", icon: <IconMail size={24} color='white' />, value: 9028, percent: "32.5", iconBg: "#2889ff", isCurrency: true },
        { label: "Organic Search", icon: <IconChartPie2Filled size={24} color='white' />, value: 9028, percent: "32.5", iconBg: "#0f9384", isCurrency: true },
    ]

    return (
        <div className='mt-4'>

            <div className='mb-4'>
                <SalesStatsCard analyticsData={salesAnalyticsData} statsData={topCardData} />
            </div>

            <Row className="g-3 mb-4 ">
                <Col md={5}>
                    <TopLeadCampaigns />
                </Col>
                <Col md={3}>
                    <SalesStatusCard />
                </Col>
                <Col md={4}>
                    <FunnelSnapshot />
                </Col>
            </Row>

            <div className='mb-4'>
                <SalesStatsCard analyticsData={salesAnalyticsData} statsData={socialData} />
            </div>
            <Row className="mb-4 d-flex align-items-stretch g-3" style={{ height: "25rem" }}>
                <Col md={5} className="h-100">
                    <LeadSourceOverview />
                </Col>
                <Col md={7} className="h-100">
                    <CampaignPerformance />
                </Col>
            </Row>
        </div>
    )
}